import React, { useState, useEffect, useContext } from "react";
import SideBar from "../inc/SideBar";
import NavBar from "../inc/NavBar";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import TextInputWithLabel from "../customcomponents/TextInputWithLabel";
import { price_Edit, price_Fetch } from "../services/ApiCalls";
import { ToastContainer, toast } from "react-toastify";
import LoadingContext from "../services/LoadingContext";
import { AppStoreContext } from "../../store/AppStore";

const Pricing = () => {
  const { setIsLoading } = useContext(LoadingContext);
  const { userDetail } = useContext(AppStoreContext);
  const { _id } = userDetail || {};

  const [mottruckMargin, setMottruckMargin] = useState("15");
  const [preferredMargin, setPreferredMargin] = useState("0");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPrice = () => {
    const payload = { adminId: _id };
    setIsLoading(true);
    price_Fetch(payload)
      .then((res) => {
        const data = res?.result?.data || {};
        setMottruckMargin(
          String(
            data.mottruck_carriers_margin != null
              ? data.mottruck_carriers_margin
              : 15
          )
        );
        setPreferredMargin(
          String(
            data.preferred_carriers_margin != null
              ? data.preferred_carriers_margin
              : 0
          )
        );
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Could not load pricing.");
      })
      .finally(() => setIsLoading(false));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const mottruck = Number(mottruckMargin);
    const preferred = Number(preferredMargin);
    if (!Number.isFinite(mottruck) || mottruck < 0) {
      toast.error("Mottruck carriers rate must be a valid number ≥ 0.");
      return;
    }
    if (!Number.isFinite(preferred) || preferred < 0) {
      toast.error("Preferred carriers rate must be a valid number ≥ 0.");
      return;
    }

    setSaving(true);
    setIsLoading(true);
    try {
      const res = await price_Edit({
        adminId: _id,
        mottruck_carriers_margin: mottruck,
        preferred_carriers_margin: preferred,
      });
      if (res?.status) {
        toast.success("Pricing updated.");
        fetchPrice();
      } else {
        toast.error(res?.msg || "Update failed.");
      }
    } catch (err) {
      console.log(err);
      toast.error("Update failed.");
    } finally {
      setSaving(false);
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="d-flex" id="wrapper">
        <SideBar />
        <div id="page-content-wrapper">
          <NavBar />
          <Container fluid className="pt-100">
            <div className="quotes_div">
              <h3 className="mb-2">Pricing</h3>
              <p style={{ color: "#555", maxWidth: 640, marginBottom: 28 }}>
                Final price (HT) = carrier price HT × (1 + margin %). VAT is
                applied afterwards according to French / non-French carrier and
                shipper rules.
              </p>

              <Form onSubmit={handleSave} style={{ maxWidth: 520 }}>
                <Row className="g-3">
                  <Col xs={12}>
                    <TextInputWithLabel
                      label="Mottruck carriers (%)"
                      type="number"
                      value={mottruckMargin}
                      onChange={(e) => setMottruckMargin(e.target.value)}
                      placeholder="e.g. 15"
                    />
                    <small style={{ color: "#777" }}>
                      Applied to Mottruck network carriers. Example: 15 →
                      carrier HT × 1.15
                    </small>
                  </Col>
                  <Col xs={12} className="mt-3">
                    <TextInputWithLabel
                      label="Preferred carriers (%)"
                      type="number"
                      value={preferredMargin}
                      onChange={(e) => setPreferredMargin(e.target.value)}
                      placeholder="e.g. 0"
                    />
                    <small style={{ color: "#777" }}>
                      Applied when the shipper uses a preferred carrier.
                    </small>
                  </Col>
                  <Col xs={12} className="mt-4">
                    <Button type="submit" disabled={saving}>
                      {saving ? "Saving…" : "Save"}
                    </Button>
                  </Col>
                </Row>
              </Form>

              <div
                style={{
                  marginTop: 36,
                  padding: 16,
                  border: "1px solid #e5e5e5",
                  borderRadius: 8,
                  maxWidth: 640,
                  fontSize: 13,
                  color: "#444",
                  lineHeight: 1.55,
                }}
              >
                <strong>VAT rules</strong>
                <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                  <li>
                    FR carrier + FR shipper → VAT on carrier price &amp;
                    platform margin
                  </li>
                  <li>
                    FR carrier + non-FR shipper → VAT on carrier price only
                  </li>
                  <li>
                    Non-FR carrier + FR shipper → VAT on platform margin only
                  </li>
                  <li>Non-FR + non-FR → no VAT</li>
                </ul>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Pricing;
